module.exports = __webpack_public_path__ + "static/3.2-d9098d090b7371bc703fb5c9a7fc843b.jpg";